import {Asset, AssetType} from "../../models/assets/asset";
import { Media } from "../../models/assets/media";
import {EntityType, mediaService} from "../../services/media-service";
import { Extension } from "../../constants/extension";
import { MINISTRY_NAMES } from "./ministry-names";

/**************************
 * 7 Weeks Harvest
 * ***********************/
export const HARVEST_PHOTOS : Asset[] = [];
export const HARVEST_LOGO: Asset = {
        id: 1,
        name: "Harvest Program Logo",
        url: "/logos/7weeks.svg",
        type: AssetType.LOGO
};
export const HARVEST_COVER: Asset = {
        id: 2,
        name: "Harvest Program Cover",
        url: "/logos/7weeks.svg",
        type: AssetType.COVER
};
export const HARVEST_VIDEOS: Asset[] = [];
export const HARVEST_FILES: Asset[] = [
    {
        id: 8,
        name: "Harvest Program PDF",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.SEVEN_WEEKS_HARVEST, AssetType.PDF, Extension.PDF, 1),
        type: AssetType.PDF,
    }
];
export const HARVEST_MEDIA_EN: Media = {
    logo: HARVEST_LOGO,
    cover: HARVEST_COVER,
    videos: HARVEST_VIDEOS,
    photos: HARVEST_PHOTOS,
    files: HARVEST_FILES,
};
export const HARVEST_MEDIA_AR: Media = {
    logo: HARVEST_LOGO,
    cover: HARVEST_COVER,
    videos: HARVEST_VIDEOS,
    photos: HARVEST_PHOTOS,
    files: HARVEST_FILES,
};
/**************************
 * Jubilee
 * ***********************/
export const JUBILEE_MEDIA_EN: Media = {
    logo: {
        id: 3,
        name: "Jubilee Program Logo",
        url: "/logos/7weeks.svg",
        type: AssetType.LOGO
    },
    cover: {
        id: 4,
        name: "Jubilee Program Cover",
        url: "/logos/7weeks.svg",
        type: AssetType.COVER
    },
    videos: [],
    photos: [],
    files: [],
};
export const JUBILEE_MEDIA_AR: Media = {
    logo: {
        id: 3,
        name: "شعار برنامج اليوبيل",
        url: "/logos/7weeks.svg",
        type: AssetType.LOGO
    },
    cover: {
        id: 4,
        name: "غلاف برنامج اليوبيل",
        url: "/logos/7weeks.svg",
        type: AssetType.COVER
    },
  videos: [],
    photos: [],
    files: [],
};
/**************************
 * Journey
 * ***********************/
export const JOURNEY_PHOTOS : Asset[] = [
    {
        id: 8,
        name: "Journey Discipleship Photos",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.JOURNEY, AssetType.IMAGE, Extension.PNG, 1),
        type: AssetType.IMAGE
    },
    {
        id: 8,
        name: "Journey Discipleship Photos",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.JOURNEY, AssetType.IMAGE, Extension.PNG, 2),
        type: AssetType.IMAGE
    },
]
export const JOURNEY_LOGO: Asset = {
        id: 5,
        name: "Journey Discipleship Logo",
        url: "/logos/journey-logo.svg",
        type: AssetType.LOGO
};
export const JOURNEY_COVER: Asset = {
        id: 6,
        name: "Journey Discipleship Cover",
        url: "/logos/journey-logo.svg",
        type: AssetType.COVER
};

export const JOURNEY_MEDIA_EN: Media = {
    logo: JOURNEY_LOGO,
    cover: JOURNEY_COVER,
    videos: [],
    photos: JOURNEY_PHOTOS,
    files: [],
};
export const JOURNEY_MEDIA_AR: Media = {
   logo: JOURNEY_LOGO,
    cover: JOURNEY_COVER,
    videos: [],
    photos: JOURNEY_PHOTOS,
    files: [],
};
/**************************
 * Youth - Chosen Generation
 * ***********************/
export const YOUTH_PHOTOS : Asset[] = [
    {
        id: 8,
        name: "Youth Prophetic Worship",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.CHOSEN, AssetType.IMAGE, Extension.PNG, 1),
        type: AssetType.IMAGE
    },
    {
        id: 8,
        name: "Youth Prophetic Worship",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.CHOSEN, AssetType.IMAGE, Extension.PNG, 2),
        type: AssetType.IMAGE
    },
    {
        id: 8,
        name: "Youth Prophetic Worship",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.CHOSEN, AssetType.IMAGE, Extension.PNG, 3),
        type: AssetType.IMAGE
    },
    {
        id: 8,
        name: "Youth Prophetic Worship",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.CHOSEN, AssetType.IMAGE, Extension.PNG, 4),
        type: AssetType.IMAGE
    },
    {
        id: 8,
        name: "Youth Prophetic Worship",
        url: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.CHOSEN, AssetType.IMAGE, Extension.PNG, 5),
        type: AssetType.IMAGE
    }
]
export const YOUTH_LOGO: Asset = {
        id: 7,
        name: "Chosen Generation Logo",
        url: "/logos/chosen.svg",
        type: AssetType.LOGO
};
export const YOUTH_COVER: Asset = {
        id: 7,
        name: "Chosen Generation Logo",
        url: "/logos/chosen.svg",
        type: AssetType.COVER
};
export const YOUTH_VIDEOS: Asset[] = [
    {
        id: 8,
        name: "Chosen Generation Worship",
        url: 'https://youtu.be/1rcrM3olVlo',
        type: AssetType.VIDEO,
        thumbnailUrl: mediaService.getMediaUrl(EntityType.MINISTRY, MINISTRY_NAMES.CHOSEN, AssetType.IMAGE, Extension.PNG, 1)
    }
];
export const YOUTH_MEDIA_EN: Media = {
    logo: YOUTH_LOGO,
    cover: YOUTH_COVER,
    videos: YOUTH_VIDEOS,
    photos: YOUTH_PHOTOS,
    files: [],
};
export const YOUTH_MEDIA_AR: Media = {
    logo: YOUTH_LOGO,
    cover: YOUTH_COVER,
    videos: YOUTH_VIDEOS,
    photos: YOUTH_PHOTOS,
    files: [],
};
/**************************
 * Goodness and Mercy
 * ***********************/
export const GOODNESS_MERCY_MEDIA_EN: Media = {
    logo: {
        id: 9,
        name: "Goodness and Mercy Logo",
        url: "/logos/goodness-mercy-logo.svg",
        type: AssetType.LOGO
    },
    cover: {
        id: 10,
        name: "Goodness and Mercy Cover",
        url: "/logos/goodness-mercy-logo.svg",
        type: AssetType.COVER
    },
    videos: [],
    photos: [],
    files: [],
};
export const GOODNESS_MERCY_MEDIA_AR: Media = {
    logo: {
        id: 9,
        name: "شعار الخير والرحمة",
        url: "/logos/goodness-mercy-logo.svg",
        type: AssetType.LOGO
    },
    cover: {
        id: 10,
        name: "غلاف الخير والرحمة",
        url: "/logos/goodness-mercy-logo.svg",
        type: AssetType.COVER
    },
    videos: [],
    photos: [],
    files: [],
};
/**************************
 * Evangelism Sector
 * ***********************/
export const EVANGELISM_PHOTOS : Asset[] = [
     {
        id: 8,
        name: "Evangelism Photos",
        url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 1),
        type: AssetType.IMAGE
    },
    {
        id: 8,
        name: "Evangelism Photos",
        url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 2),
        type: AssetType.IMAGE
    },
    {
        id: 8,
        name: "Evangelism Photos",
        url: mediaService.getMediaUrl(EntityType.EVENT, "monthly-worship-encounter", AssetType.IMAGE, Extension.PNG, 3),
        type: AssetType.IMAGE
    }
];
export const EVANGELISM_LOGO: Asset = {
        id: 7,
        name: "Worship Encounter Logo",
        url: "/logos/worship-encounter.svg",
        type: AssetType.LOGO
};
export const EVANGELISM_COVER: Asset = {
        id: 7,
        name: "Worship Encounter Cover",
        url: "/logos/worship-encounter.svg",
        type: AssetType.COVER
};
export const EVANGELISM_MEDIA_EN: Media = {
    logo: EVANGELISM_LOGO,
    cover: EVANGELISM_COVER,
    videos: [],
    photos: EVANGELISM_PHOTOS,
    files: [],
};
export const EVANGELISM_MEDIA_AR: Media = {
    logo: EVANGELISM_LOGO,
    cover: EVANGELISM_COVER,
    videos: [],
    photos: EVANGELISM_PHOTOS,
    files: [],
};